function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  className: "style-scope yt-icon"
}, React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  className: "style-scope yt-icon"
}, React.createElement("path", {
  d: "M26.88 35.72l-5.52-5.52 5.52-5.52L25.2 23 18 30.2l7.2 7.2 1.68-1.68zm6.24 0l5.52-5.52-5.52-5.52L34.8 23l7.2 7.2-7.2 7.2-1.68-1.68z",
  fill: "currentColor",
  fillRule: "nonzero",
  className: "style-scope yt-icon"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      "pointerEvents": "none",
      "display": "block",
      "width": "100%",
      "height": "100%"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/embed.1f26c81e.svg";
export { SvgComponent as ReactComponent };